export class DeviceType implements IDeviceType {
  id?: string | undefined;
  platformId?: string | undefined;
  isActive?: boolean;
  title?: string | undefined;

  constructor(data?: IDeviceType) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.platformId = _data['platformId'];
      this.isActive = _data['isActive'];
      this.title = _data['title'];
    }
  }

  static fromJS(data: any): DeviceType {
    data = typeof data === 'object' ? data : {};
    const result = new DeviceType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['platformId'] = this.platformId;
    data['isActive'] = this.isActive;
    data['title'] = this.title;
    return data;
  }
}

export interface IDeviceType {
  id?: string | undefined;
  platformId?: string | undefined;
  isActive?: boolean;
  title?: string | undefined;
}